import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit,
  faUserCog,
} from '@fortawesome/free-solid-svg-icons';
import pad from 'pad';
import Switch from "react-switch";


const customStyles = {
  rows: {
    style: {
      minHeight: '72px', // override the row height
    }
  },
  headCells: {
    style: {
      paddingLeft: '8px', // override the cell padding for head cells
      paddingRight: '8px',
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
    },
  },
};

const colummnsWithFunc = (callbackEdit, callbackDel, goConfig) => {
  return [
    {
      name: 'Codigo',
      selector: 'id',
      sortable: true,
      cell: row => (
        pad(5, row.id, '0')
      ),
      grow: 0,
    },
    {
      name: 'Sucursal',
      selector: 'description',
      sortable: true,
    },
    {
      name: 'Dirección',
      selector: 'address',
      sortable: true,
    },
    {
      name: 'Acciones',
      width: '15%',
      right: true,
      cell: (row) => (
        <div style={{ margin: 5, display: 'flex' }}>
          <button onClick={() => callbackEdit(row)} className="btnx btnx-warn icon-table">
            <FontAwesomeIcon icon={faEdit} />
          </button>{' '}
          <button onClick={() => goConfig(row.uuid)} className="btnx btnx-warn icon-table">
            <FontAwesomeIcon icon={faUserCog} />
          </button>
        </div>
      )
    },
  ];
}

const columnsUsuarios = (callbackEdit, callbackDel, setValue) => {
  return [
    {
      name: 'Usuario',
      selector: 'username',
      sortable: true,
    },
    {
      name: 'Estado',
      selector: 'status',
      sortable: true,
      cell: row => (
        <Switch
          onChange={() => setValue(row.status, row.id)}
          checked={row.status ? true : false}
          onColor="#ff6d25"
        />
      )
    },
    {
      name: 'Rol usuario',
      selector: row => row.rol.description,
      sortable: true,
    },
    {
      name: 'Acciones',
      width: '15%',
      right: true,
      cell: (row) => (
        <div style={{ margin: 5, display: 'flex' }}>
          <button onClick={() => callbackEdit(row)} className="btnx btnx-warn icon-table">
            <FontAwesomeIcon icon={faEdit} />
          </button>
        </div>
      )
    },
  ];
}

const table = {
  customStyles,
  colummnsWithFunc,
  columnsUsuarios,
}

export default table;